import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserDetailService } from './user-detail.service';

@Injectable({
    providedIn: 'root'
})
export class DocumentManagementMasterService {

    constructor(private http: HttpClient, private httpService: HttpService, private userDetailService: UserDetailService) {

    }


    // getDocumentNameList(){
    //     return this.http.get(environment.pssUrl + 'documentManagement/')
    //     .map(res => res.json());     
    // }

    getParentSubDocumentManagementList(id: string) {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'getChilds/' + id, { headers: headers })
            .map((res: Response) => res.json());
    }


    getDocumentTypeList() {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'documentTypeparent/', { headers: headers })
            .map((res: Response) => res.json());
    }

    getMeetingList() {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'meetingType/', { headers: headers })
            .map((res: Response) => res.json());
    }


    getDocumentManagementList() {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'documentManagement/', { headers: headers })
            .map((res: Response) => res.json());

    }
    getUploadedDocumentList() {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'documentManagement/', { headers: headers })
            .map((res: Response) => res.json());
    }



    getKmpList() {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'meetingType/', { headers: headers })
            .map((res: Response) => res.json());
    }

    getKmpDetailsList() {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'kmpMaster/' + '5a5b43bd3202413a5c81636f', { headers: headers })
            .map((res: Response) => res.json());
    }

    getDirectorDetailsList() {
        var request = {
            URL: "directorMaster/" + '5a5b43bd3202413a5c81636f',

        }
        return this.httpService.get(request);
        // return this.http.get(environment.pssUrl + 'directorMaster/' + '5a5b43bd3202413a5c81636f')
        //     .map(res => res.json());
    }

    getDirectorList() {
        var request = {
            URL: 'directorMaster/getDirectorDetails/',

        }
        return this.httpService.get(request);
        // return this.http.get(environment.pssUrl + 'directorMaster/getDirectorDetails/')
        //     .map(res => res.json());

    }
    getTypeList(type: string, id) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (type == 'KMP') {
            // return this.http.get(environment.pssUrl + 'kmpMaster/null')
            //     .map(res => res.json());
            var request = {
                URL: "kmpMaster/" + id,
            }
            return this.httpService.get(request);
        } else {
            // return this.http.get(environment.pssUrl + 'directorMaster/null')
            //     .map(res => res.json());
            var request = {
                URL: "directorMaster/" + id,

            }
            return this.httpService.get(request);
        }


    }

    addDocumentManagement(newDocumentManagement) {
        var headers = this.addHeaders();
        var documentArray = [];
        documentArray[0] = newDocumentManagement;
        // headers.append('Content-Type', 'application/json');
        return this.http.post(environment.pssServerUrl + 'documentManagement/', documentArray, { headers: headers })
            .map((res) => res);
    }

    // addMultiplePdfDocuments(newDocumentManagement) {
    //     // var headers = new Headers();
    //     var headers = this.addHeaders();

    //     // headers.append('Content-Type', 'application/json');
    //     return this.http.post(environment.pssUrl + 'documentManagement/uploadAgendaAttachment', newDocumentManagement,{headers:headers})
    //         .map(res => res.json());
    // }


    addMultipleDocuments(newDocumentManagement) {
        // var headers = new Headers();
        var headers = this.addHeaders();

        // headers.append('Content-Type', 'application/json');
        return this.http.post(environment.pssServerUrl + 'documentManagement/bulkUpload', newDocumentManagement, { headers: headers })
            .map((res: Response) => res.json());
    }

    // var headers = new Headers();
    //     headers.append('Content-Type', 'application/json');
    //     return this.http.get(environment.pssUrl + 'documentManagement/downloadAllAsZip/' + documentManagementId)
    //         .map(res => res.json());   
    getDocumentManagementById(documentManagementId: string) {
        var headers = this.addHeaders();

        return this.http.get(environment.pssServerUrl + 'documentManagement/' + documentManagementId, { headers: headers })

            .map((res: Response) => res.json());
    }

    deleteDocumentManagement(documentManagementId) {
        var headers = this.addHeaders();
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        return this.http.get(environment.pssServerUrl + 'documentManagement/delete/' + documentManagementId, { headers: headers })
            .map((res: Response) => res.json());
    }

    updateDocumentManagement(updatedDocumentManagement) {
        console.log('updatedDocumentManagement');
        var headers = this.addHeaders();
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        return this.http.post(environment.pssServerUrl + 'documentManagement/edit/', updatedDocumentManagement, { headers: headers })
            .map((res: Response) => res.json());
    }

    updateDocumentOnly(updatedDocumentManagement) {
        console.log('updatedDocumentManagement');
        var headers = this.addHeaders();
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        return this.http.post(environment.pssServerUrl + 'documentManagement/fileUpate', updatedDocumentManagement, { headers: headers })
            .map((res: Response) => res.json());
    }


    fileUpload(updatedDocumentManagement, idObject) {
        console.log('updatedDocumentManagement');

        var headers = this.addHeaders();

        return this.http.post(environment.pssServerUrl + 'documentManagement/fileUpload/' + idObject._id, updatedDocumentManagement, { headers: headers })
            .map((res: Response) => res.json());
    }

    downloadFile(id) {
        var headers = this.addHeaders();
        return this.http.get(environment.pssServerUrl + 'documentManagement/downloadFile/' + id, { headers: headers })
            .map((res: Response) => res.json());
    }


    getDocumentSearch(searchParam) {
        var headers = this.addHeaders();
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        return this.http.post(environment.pssServerUrl + 'documentManagement/search/', searchParam, { headers: headers })
            .map((result: Response) => result.json());
    }

    updateDocumentManagementInMeeting(newDocumentManagement, docID) {
        var request = {
            URL: 'documentManagement/updateDocInMeeting/' + docID,
            DATA: newDocumentManagement
        }
        return this.httpService.post(request);
    }


    addHeaders() {

        var PSSDetail = this.userDetailService.pssDetail();
        var UserDetail = this.userDetailService.getUserDetail();
        var getUserID = this.userDetailService.getUserID();
        var headers = new HttpHeaders();
        let params = new URLSearchParams();
        // params.append("someParamKey", this.someParamValue)
        headers = headers.set('Content-Type', 'application/json');

        // Setting custom headers
        headers = headers.set('PSSDetail', (PSSDetail)); // Assuming PSSDetail is an object
        headers = headers.set('UserDetail', (UserDetail)); // Assuming UserDetail is an object

        var token = localStorage.getItem('token')
        headers.append("x-access-token", token)
        return headers;


        //   var PSSDetail = this.userDetailService.pssDetail();
        //   var UserDetail = this.userDetailService.getUserDetail();


        //   var getUserID = this.userDetailService.getUserID();
        //   var headers = new HttpHeaders();
        //   headers.append('Content-Type', 'application/json');
        //   var token = localStorage.getItem('token')
        //   headers.append("x-access-token", token)

        //   headers.append('PSSDetail', PSSDetail);
        //   headers.append('UserDetail', UserDetail);
        //   return headers;
    }

    addMultiplePdfDocuments(newDocumentManagement) {
        const headers = this.addHeaders();
        return this.http.post(environment.pssServerUrl + 'documentManagement/uploadAgendaAttachment', newDocumentManagement, { headers });
    }




}
